import { Component, Input } from '@angular/core';
import { NgIcon } from '@ng-icons/core';

/**
 * Was eine Seite zeigt, wenn es nichts zu zeigen gibt.
 *
 * Eine leere Liste ist sonst eine leere Flaeche, und die liest sich als
 * Fehler: geladen, kaputt oder falsch abgebogen? Symbol und ein Satz sagen,
 * dass hier nichts fehlt — und was als Naechstes ginge, steht als Knopf im
 * Inhalt der Komponente.
 */
@Component({
  selector: 'app-empty-state',
  imports: [NgIcon],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss',
})
export class EmptyStateComponent {
  @Input({ required: true }) icon!: string;
  @Input({ required: true }) title!: string;
  @Input() text = '';
}
